<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/person/index"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>
      <el-drawer
        :title="drawerTitle"
        :visible.sync="isShowDrawer"
        direction="rtl"
      >
        <div style="padding: 40px" v-loading="loading">
          <el-form :model="info" labelWidth="100px" size="medium">
            <!-- 单选：团队、个人 -->
            <el-form-item label="类型" prop="type">
              <el-radio-group v-model="info.type">
                <el-radio :label="0">个人</el-radio>
                <el-radio :label="1">团队</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="info.type == 0" label="身份证扫描">
              <el-upload
                class="uploader"
                action="#"
                :show-file-list="false"
                :on-change="handleChangeIdCardFile"
                :before-upload="beforeUpload"
                :auto-upload="false"
              >
                <el-button type="primary">上传身份证照片</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="info.type == 1" label="营业执照扫描">
              <el-upload
                class="uploader"
                action="#"
                :show-file-list="false"
                :on-change="handleChangeLicenseFile"
                :before-upload="beforeUpload"
                :auto-upload="false"
              >
                <el-button type="primary">上传营业执照照片</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="info.personName" required></el-input>
            </el-form-item>
            <el-form-item label="证件号">
              <el-input v-model="info.certNo" required></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input v-model="info.tel" required></el-input>
            </el-form-item>
            <el-form-item label="地址">
              <el-input v-model="info.addr" required></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="info.email"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Privy",
  comments: {},
  data() {
    return {
      tableData: [],
      isShowDrawer: false,
      info: {},
      searchData: {},
      isEdit: false,
      drawerTitle: "",
      loading: false,
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {},
  methods: {
    add() {
      this.info = { type: 0 };
      this.isShowDrawer = true;
      this.drawerTitle = "新增关系人";
    },

    edit(row) {
      this.info = { ...row };
      this.isEdit = true;
      this.isShowDrawer = true;
      this.drawerTitle = "编辑关系人";
    },

    // 图片上传之前
    beforeUpload(file) {
      console.log(file);
    },

    // 上传身份证照片
    async handleChangeIdCardFile(file) {
      console.log(file);
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      fd.append("side", "front");
      console.log(fd);
      const res = await this.$api.upload("/admin/upload/upload_iden", fd);
      this.loading = false;
      if (!res) return;
      if (!res.data.is_iden) {
        this.$message.warning("只支持身份证照片");
        return;
      }
      if (!res.data.info.status !== "normal") {
        this.$message.warning(
          "检测到您上传的照片有遮挡或者模糊，会导致信息识别不全"
        );
      }
      this.info = {
        ...this.info,
        personName: res.data.info.name,
        addr: res.data.info.addr,
        certNo: res.data.info.iden_num,
      };
    },

    // 上传营业执照照片
    async handleChangeLicenseFile(file) {
      console.log(file);
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      fd.append("side", "front");
      console.log(fd);
      const res = await this.$api.upload("/admin/upload/business", fd).catch(() => {
        this.loading = false;
      });
      this.loading = false;
      if (!res) return;
      if (!res.data.code) {
        this.$message.warning("只支持营业执照照片");
        return;
      }

      this.info = {
        ...this.info,
        personName: res.data.unit_name,
        addr: res.data.address,
        certNo: res.data.code,
      };
    },

    del(row) {
      this.$confirm("是否确认删除该关系人信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/person/del",
              {
                personId: row.personId,
              },
              "删除"
            )
            .then(() => {
              this.$refs.baseTable.searchData();
            });
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    onSubmit() {
      this.$api.post("/admin/person/save", this.info, "更新").then(() => {
        this.isShowDrawer = false;
        this.handleSearch();
      });
    },

    // 点击搜索
    handleSearch() {
      // console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      // console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
